(function (exports) {


    // Put functions into DataTableInit
    function DataTableInit(){}


    DataTableInit.prototype.construct = function(datatable, hasCheckboxes = false) {

        if($('.data-table')) {

            // Get selectbox over table and sort table base off value
            $('.mobile-sort').change(function() {

                // Get selected index
                var index;
                if(hasCheckboxes) {
                    // First 2 options don't select checkbox column ASC and DESC
                    index = $(this)[0].selectedIndex + 2;
                } else {
                    index = $(this)[0].selectedIndex ;
                }
                var order = 'desc';
                var colIndex = 0;

                // If selected index is even then ASC else stay as DESC
                if(index % 2 == 0) {
                    order = 'asc';
                }

                // Make so colIndex is calculated based off index
                colIndex = Math.floor(index / 2);

                // Re-order table
                datatable.order( [ [colIndex, order] ] ).draw();
            });


            datatable.on( 'processing.dt', function ( e, settings, processing ) {
                if(processing) {
                    $('.data-table').css('opacity', '0.2');
                    $('.data-table').css('transition', '0.2s ease-out');
                } else {
                    $('.data-table').css('opacity', '1');
                    $('.data-table').css('transition', '0.2s ease-in');

                }
            } )

        }
    }


    // table rows redirect on click
    DataTableInit.prototype.makeRowsClickable = function() {

        $('td').click(function(event){
            //event.stopPropagation();

            if(!$(this).hasClass('checkbox-td')){

                var dataHref = $(this).parent().attr('data-href') ;

                if( dataHref ) {
                    window.location.href = dataHref;
                }
            }

        });
    }



    DataTableInit.prototype.addDropdownArrowsSelectbox = function () {

        var sortContainer = $('.dataTables_length label select');
        sortContainer.wrap('<div class="dt-select-with-dropdown-arrow"></div>');

    }

    DataTableInit.prototype.handlePaginationState = function () {
        // If only page then don't display next/prev
        if( $('.paginate_button').length <= 3 ) {

            $('.paginate_button.previous').addClass('pagination-disabled')
            $('.paginate_button.next').addClass('pagination-disabled');

        } else if ( $('.current').attr('data-dt-idx') == 1 ) {

            $('.paginate_button.previous').addClass('pagination-disabled')

        } else if ( $('.current').attr('data-dt-idx') == $('.dataTables_paginate span').children().length ) {

            $('.paginate_button.next').addClass('pagination-disabled');

        }
    }


    DataTableInit.prototype.addDropdownArrows = function () {
        // Add ability to put dropdown arrows next to th text
        $('th').each(function() {
            var text = $(this).text();
            $(this).text("");
            $(this).html('<div class="sort-arrow-container">' + text + '</div>');
        });
    }

    DataTableInit.prototype.addSearchCross = function () {
        $('.dataTables_filter input').wrap('<span class="search-container"></span>');
        $('.search-container').append('<div class="search-cross"></div>');

        // Add cross to search field
        $('.dataTables_filter input').keyup(function() {
            if($('.dataTables_filter input').val().length > 0) {
                $('.search-cross').addClass('search-cross--active');
            } else {
                $('.search-cross').removeClass('search-cross--active');
            }
        });

        // When cross clicked remove text + cross and reset datatable
        $('.search-cross').click(function() {
            $('.search-container input').val('');
            location.reload();
        });
    }


    if (typeof define === 'function' && define.amd) {
        define(function() { return DataTableInit.prototype; });
    } else if (typeof module !== 'undefined' && module.exports) {
        module.exports = DataTableInit.prototype;
    } else {
        exports.DataTableInit = DataTableInit.prototype;
    }

})(this);



// WEBPACK FOOTER //
// ./datatable.js